import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { transactionInfoFeatureKey, transactionInfoReducer } from './state/transaction-info.reducer';
import { TransactionInfoEffects } from './state/transaction-info.effects';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(transactionInfoFeatureKey, transactionInfoReducer),
    EffectsModule.forFeature([TransactionInfoEffects])
  ]
})
export class TransactionInfoModule { }